export default {
  name: 'Chat',

  props: {
    item: Object,
  },
  data() {
    return {
      panel: [0, 1],
      message: null,
      dialog: false,
      openFileDialog: false,
      fileURL: '',
      intervalId: null,
      document: {
        base64: '',
        name: '',
        filename: '',
        url: '',
      },
      errors: [],
      newTicket: {
        application_id: this.item.id,
        title: '',
        comment: '',
        contact: 'chat',
      },
      theme: '',
      contact: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
      fullChat: false,
      hasImage: false,
      selectedQuestion: false,
    };
  },
  watch: {
    user() {
      this.loadTickets();
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    tickets() {
      return this.$store.state.design.tickets;
    },
    ticket() {
      return this.$store.state.design.ticket;
    },
    displayTickets() {
      return this.tickets;
    },
    validation() {
      return (
        this.newTicket.application_id
        && this.newTicket.title
        && this.newTicket.contact
        && this.newTicket.comment
      );
    },
    manager() {
      return this.$store.state.user.personal_manager;
    },
  },
  methods: {
    addFile() {
      // eslint-disable-next-line no-alert
      alert('я еще не работаю');
    },
    /** Показать скрыть полный чат */
    ShowFullChat() {
      this.fullChat = !this.fullChat;
    },
    /** Открыть файл в тикете */
    OpenFile(file) {
      this.openFileDialog = true;
      this.fileURL = file;
    },
    /** проверка на тип файла прикрепленного к тикету */
    CheckPDF(file) {
      return file.indexOf('/pdf;') !== -1 || file.indexOf('.pdf') !== -1;
    },
    /** Счетчик непрочтенных сообщений */
    GetNewMessagesCounter(messages) {
      const newMessages = messages.filter(
        item => item.admin_id && !item.readed,
      );
      return newMessages.length ? newMessages.length : '';
    },
    /** Открыть сообщения тикета в левой части */
    OpenTicket(ticket) {
      const payload = {
        ticket_id: ticket.id,
        profile_id: this.user.profile_id,
      };
      this.$store.dispatch('design/SetTicket', payload).then(() => {
        // скроллим чат в самый низ
        const container = document.getElementById('messageContainer');
        if (container) {
          const lastChild = container.children[container.children.length - 1];
          if (lastChild) {
            container.scrollTop = lastChild.offsetTop;
          }
        }
      });
    },
    setImage(e) {
      if (e && e.dataUrl) {
        this.document = {
          id: null,
          name: e.info ? e.info.name : '',
          base64: e.dataUrl,
          filename: '',
          url: '',
        };
      } else {
        this.document = {
          filename: '',
          base64: '',
          name: '',
          url: '',
          id: null,
        };
      }
    },
    startImageResize() {
      this.$store.dispatch('SetLoading', true);
    },
    endImageResize() {
      this.$store.dispatch('SetLoading', false);
    },
    /** Открыть форму добавления обращения */
    OpenNewTicketForm() {
      this.dialog = true;
    },
    /** Скрыть форму добавления обращения */
    CloseNewTicketForm() {
      this.newTicket = {
        application_id: this.item.id,
        title: '',
        comment: '',
        contact: 'chat',
      };
      this.dialog = false;
    },
    /** Удаление документа из списка прикрепленных файлов. */
    DeleteDocument() {
      this.document = { filename: '', base64: '', name: '', url: '' };
    },
    /** Добавить сообщение в тикет */
    PostMessage() {
      const app = this;
      const data = {
        message: app.message,
        file: app.document.base64,
        profile_id: app.user.profile_id,
        ticket_id: app.ticket.id,
      };
      app.$store.getters.axl
        .post('design/api/messages/add', data)
        .then((response) => {
          app.AddMessage(response.data.message);
          app.document.base64 && app.DeleteDocument();
          app.message = '';
          app.OpenTicket(app.ticket);
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    AddMessage(message, incomming) {
      const app = this;
      incomming = incomming || null;
      app.ticket.messages.push(message);
      if (incomming) {
        app.ChatReaded(incomming);
        app.PublishChatReaded();
      }
    },
    /** Отправить признак прочитанности сообщения */
    PublishChatReaded() {
      const payload = {
        profile_id: this.user.profile_id,
        ticket_id: this.ticket.id,
      };
      this.$store.dispatch('design/ReadedTicket', payload);
    },
    /** Добавить новый тикет-обращение */
    AddNewTicket() {
      const app = this;
      const payload = {
        ...app.newTicket,
        profile_id: this.user.profile_id,
      };

      app.$store.getters.axl
        .post('design/api/tickets/send-ticket', payload)
        .then((response) => {
          app.$store.dispatch(
            'ShowInfo',
            'Обращение отправлено! Ожидайте ответ в ближайшее время',
          );
          console.log('AddNewTicket', response.data.ticket);
          app.OpenTicket(response.data.ticket);
          app.CloseNewTicketForm();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    loadTickets() {
      this.$store.dispatch('design/GetTickets', {
        profileId: this.user.profile_id,
        type: 'specialist',
      });
    },
    getUnreadMessagesCount(ticket) {
      return ticket.messages.filter(m => !m.readed && m.admin_id).length;
    },
  },
  created() {},
  mounted() {
    this.user && this.loadTickets();
    this.intervalId = setInterval(() => {
      this.user && this.loadTickets();
    }, 15000);
    this.$store.dispatch('design/UnsetTicket');
    this.user && this.ticket && this.PublishChatReaded();
    this.$store.dispatch('SetTitle', 'Чат с менеджером');
  },
  destroyed() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
